<template>
  <div v-if="sources.length">
    <RasterTileLayer
      v-for="(source, index) in sources"
      :key="index"
      :before="before"
      :layer="layerOrthophotoStyle(index)"
      :layerId="getOrthophotoLayerId(index)"
      :sourceId="getOrthophotoSourceId(index)"
      :source="source"
    />
  </div>
</template>

<script lang="ts" setup>
import _ from 'lodash'
import RasterTileLayer from '@/components/map/mapbox-layers/RasterTileLayer.vue'
import { computed, ref, watch } from 'vue'
import { useGeneralStore } from '@/pinia'
// import { useStore } from 'vuex'
// import useMapbox from '@/composables/useMapbox'
import { Layer } from 'mapbox-gl'

defineProps<{
  layerId: string
  before: string
}>()

const piniaStore = useGeneralStore()
// const store = useStore()
// const { map } = useMapbox()

// const currentDrawingTransparency = computed(() => store.state.mapview.currentDrawingTransparency)
const filteredOrthophotos = computed(() => piniaStore.filteredOrthophotos)
const sources = ref<{ type: string; tiles: string[] }[]>([])
async function generateGetMapUrl(orthophotoTileLayer) {
  const finalUrl =
    orthophotoTileLayer.tiledLayerUri +
    `&request=GetMap&styles&srs=epsg:3857&bbox={bbox-epsg-3857}&width=512&height=512&format=image/png&transparent=true`
  /*
  Regarding Mapbox limitations:
  Mapbox supports the popular Web Mercator projection, commonly referred to as EPSG:900913 or EPSG:3857.
  As the documentation states, By providing a URL to a WMS server that supports EPSG:3857 (or EPSG:900913) as a source of tiled data.
  The server URL should contain a "{bbox-epsg-3857}" but the service doesn't support that CRS so you can't use it.
  You might be able to cascade through another WMS service, for example GeoServer and MapServer software can do this, or you could use MapProxy.
  */
  return finalUrl
}
function layerOrthophotoStyle(index: number): Layer {
  return {
    id: getOrthophotoLayerId(index),
    source: getOrthophotoSourceId(index),
    type: 'raster',
    paint: {
      'raster-opacity':
        filteredOrthophotos.value.filter((orthophoto) => orthophoto.visible).length === 1
          ? 1 // currentDrawingTransparency.value
          : 0.6
    }
  }
}
function getOrthophotoLayerId(index: number) {
  return `layer-orthophoto-outdoor-tiles-${index}`
}
function getOrthophotoSourceId(index: number) {
  return `source-orthophoto-outdoor-tiles-${index}`
}

/* watch(currentDrawingTransparency, (newTransparency) => {
  if (
    sources.value.length !== 1 ||
    filteredDrawings.value.filter((drawing) => drawing.visible).length !== 1
  )
    return
  const layerId = getOrthophotoLayerId(0)
  if (map) map.setPaintProperty(layerId, 'raster-opacity', newTransparency)
}) */
watch(
  () => _.cloneDeep(filteredOrthophotos.value),
  async (newOrthophotos) => {
    sources.value = []
    if (!newOrthophotos.length || !newOrthophotos.some((layer) => layer.visible)) return
    const visibleOrthophotoTileLayers = newOrthophotos.filter(
      (layer) => layer.visible && layer.tiledLayerUri !== undefined
    )
    const orthophotoSources: { type: string; tiles: string[] }[] = []
    for (const layer of visibleOrthophotoTileLayers) {
      const tileUrl = await generateGetMapUrl(layer)
      orthophotoSources.push({
        type: 'raster',
        tiles: [tileUrl]
      })
    }
    sources.value = orthophotoSources
  }
)
</script>
